import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const BarGraphCard = ({ data }) => {
    if (data.length == 0) return null;
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{
                    top: 10,
                    right: 10,
                    left: 0,
                    bottom: 20,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip
                    contentStyle={{
                        left: '-45px',
                        top: '-35px',
                        zIndex: '2',
                        position: 'absolute',
                        borderRadius: '8px',
                        fontSize: '14px',
                        border: 'none',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        padding: '8px'
                    }}
                    cursor={{ fill: 'rgba(0,0,0,0.05)' }}
                />
                {/* <Bar
                    dataKey="value"
                    fill="#4299E1"
                    radius={[4, 4, 0, 0]}
                    barSize={30}
                    animationDuration={1000}
                /> */}
                <Bar
                    dataKey="value"
                    radius={[4, 4, 0, 0]}
                    barSize={30}
                    animationDuration={1000}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.fill} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default BarGraphCard;